module.exports = __webpack_public_path__ + "img/charts_statistics.4f856e9f.svg";